(function($) {

	if ($('.hv-tabs').length) {
		// clicking one of the switcher spans in desktop or mobile
		$('.hv-tabs__switcher span, .hv-tabs__dropdown__list span').on('click',function(){
			var index 	= $(this).parent().find("span").index($(this));
			var text 	= $(this).text();
			var parent 	= $(this).closest('.hv-tabs');
			// show relevant tab 
			parent.find('.hv-tabs__tab').hide().eq(index).show();
			// highlight relevant switcher
			parent.find('.hv-tabs__switcher, .hv-tabs__dropdown__list').each(function(){
				$(this).find('span').removeClass('active').eq(index).addClass('active');
			});
			// update dropdown current
			parent.find('.hv-tabs__dropdown__current').text(text);
			// collapse dropdown menu on mobile
			$('.hv-tabs__dropdown__list').slideUp()
			// reinit equalizer
			Foundation.reInit('equalizer');
		});
		// opening/closing the mobile dropdown
		$('.hv-tabs__dropdown__current').on('click',function(){
			$('.hv-tabs__dropdown__list').slideToggle().parent().toggleClass('open');
		});
	}

})( jQuery );  